import { getDocumentStateValueOptions } from '../../valueOptions';
import { createFixedOptionsFilterInput } from '../common';

export const DocumentStateFilterInput =
  createFixedOptionsFilterInput(getDocumentStateValueOptions);
